import * as UserI18N from '../../../../../l10n';
import { I18nClient } from '../../../../external/i18nClient';

export class UserI18NPort {
  public static readonly translations = UserI18N.userManagementUITranslations;
  public static readonly nameSpace = UserI18N.UM_UI_TRANSLATIONS_NAMESPACE;
  public static readonly scopedTranslator = I18nClient.createScopedTranslator(
    UserI18NPort.nameSpace,
    UserI18NPort.translations,
  );

  public readonly composeUserI18NClient = (): I18nClient => {
    const UMUII18nClient = class extends I18nClient {
      public readonly nameSpace = UserI18NPort.nameSpace;
      public readonly translations = UserI18NPort.translations;
    };

    return new UMUII18nClient();
  };

  public static readonly create = (): UserI18NPort => {
    return new UserI18NPort();
  };
}
